const filterKeyOverview = {
  TIME: "date",
  LEVEL: "level",
};

export { filterKeyOverview };
